import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Form } from "react-final-form";
import arrayMutators from "final-form-arrays";
import { Card, CardBody, CardHeader } from "reactstrap";
import { PacmanLoader } from "react-spinners";
import axios from "axios";
import _ from "lodash";

import NotAuthorized from "modules/5_view_helpers/web/NotAuthorized";
import HasRole from "modules/5_view_helpers/HasRole";
import { createStoreRequest } from "../actions";
import StoreRequestForm from "../web/form";

const blankInitial = {
  tool_account: false,
  notes: "",
  line_items_attributes: [{ description: "", quantity: 1 }],
};

const CaptureStoreRequestOutlook = (props) => {
  const { history } = props;
  const [saving, setSaving] = useState(false);
  const [capturing, setCapturing] = useState(true);
  const [captureError, setCaptureError] = useState(null);
  const [initialValues, setInitialValues] = useState(blankInitial);
  const returnUrl = "/";
  const createRole = HasRole({ resource_type: "Store::Request", name: ["create", "moderator"] }, false, true);

  // ponytail: land on outlook home, show toastr, then close after a beat
  const closeAddin = () => {
    try {
      Office.context.ui.closeContainer();
    } catch (e) {
      // already redirected
    }
  };

  useEffect(() => {
    const item = Office.context.mailbox?.item;
    if (!item) {
      setCaptureError("No Outlook email selected");
      setCapturing(false);
      return;
    }

    const subject = item.subject || "";
    const fromEmail = item.from?.emailAddress || "";
    const fromName = item.from?.displayName || "";
    item.body.getAsync("text", (result) => {
      const body = result.status === Office.AsyncResultStatus.Succeeded ? result.value : "";
      axios
        .post("/store/requests/capture.json", {
          subject,
          body,
          from_email: fromEmail,
          from_name: fromName,
        })
        .then((response) => {
          const data = response.data || {};
          setInitialValues({
            tool_account: !!data.tool_account,
            notes: data.notes || "",
            mw_job_id: data.mw_job_id || null,
            project_id: data.project_id || null,
            requested_by_email: data.requested_by_email || fromEmail || null,
            requested_by_name: data.requested_by_name || fromName || null,
            line_items_attributes: _.isEmpty(data.line_items_attributes)
              ? [{ description: "", quantity: 1 }]
              : data.line_items_attributes,
          });
          setCapturing(false);
        })
        .catch((err) => {
          setCaptureError(err?.response?.data?.error || "AI capture failed");
          setInitialValues({
            ...blankInitial,
            requested_by_email: fromEmail || null,
            requested_by_name: fromName || null,
          });
          setCapturing(false);
        });
    });
  }, []);

  const submitForm = (values) => {
    setSaving(true);
    props
      .createStoreRequest(values)
      .then(() => {
        setSaving(false);
        history.push(returnUrl);
        toastr.success("Store request created");
        setTimeout(closeAddin, 1500);
      })
      .catch(() => {
        setSaving(false);
        toastr.error("Failed to create store request");
      });
  };

  if (!createRole) {
    return <NotAuthorized />;
  }

  if (capturing) {
    return (
      <div className="text-center">
        <PacmanLoader />
        Reading email with AI...
      </div>
    );
  }

  if (saving) {
    return (
      <div className="text-center">
        <PacmanLoader />
        Saving...
      </div>
    );
  }

  return (
    <Card>
      <CardHeader>
        <h3>Store Request Capture</h3>
      </CardHeader>
      <CardBody>
        {captureError && (
          <div className="alert alert-warning" role="alert">
            {captureError}. You can still fill the form manually.
          </div>
        )}
        <Form
          component={StoreRequestForm}
          outlookMode
          onSubmit={submitForm}
          formLabel="Submit Request"
          cancelFunction={() => history.push(returnUrl)}
          mutators={{ ...arrayMutators }}
          initialValues={initialValues}
        />
      </CardBody>
    </Card>
  );
};

export default connect(null, { createStoreRequest })(CaptureStoreRequestOutlook);
